import Button from '../../../../components/bootstrap/Button';


const HeaderDisputeStatus = ({ stateSelected, handleChangeStatus }) => {
    return (

        <>
            <div style={{ display: 'flex', width: '20%', justifyContent: 'space-around' }}>

                <Button
                    type="button"
                    className={stateSelected === 'HSD' ? 'btn active' : 'btn'}
                    style={{backgroundColor: stateSelected === 'HSD' ? '#6c5dd3' : undefined, color:stateSelected === 'HSD' ? '#fff' : '#000'}}
                    data-bs-toggle="button"
                    onClick={() => handleChangeStatus('HSD')}
                >
                    Aberto
                </Button>
                <Button
                    type="button"
                    className={stateSelected === 'HSS' ? 'btn active' : 'btn'}
                    style={{backgroundColor: stateSelected === 'HSS' ? '#6c5dd3' : undefined, color:stateSelected === 'HSS' ? '#fff' : '#000'}}
                    data-bs-toggle="button"
                    onClick={() => handleChangeStatus('HSS')}
                >
                    Finalizados
                </Button>
                <Button
                    type="button"
                    className={stateSelected === 'todos' ? 'btn active' : 'btn'}
                    style={{backgroundColor: stateSelected === null ? '#6c5dd3' : undefined, color:stateSelected === null ? '#fff' : '#000'}}
                    data-bs-toggle="button"
                    onClick={() => handleChangeStatus(null)}
                >
                    Todos
                </Button>


            </div>
            

        </>
    )
}

export default HeaderDisputeStatus